<template>
    <div class="post-foot">
        <a href="https://www.instagram.com/ratesautotransport/" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/img/blog/instagram_icon.svg" alt="Instagram Icon" class="post-foot__icon" />
        </a>
        <router-link :to="`/blog/post/${post.slug}`" class="post-foot__link">
            {{ post.title }}
        </router-link>
    </div>
</template>
<style>
.post-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0 4rem 0;
    padding: 0 0 1rem;
    border-bottom: 1.5px solid var(--ComplementaryColor04);
}

.post-foot__icon {
    height: 40px;
    width: auto;
    margin: 0 !important;
    cursor: pointer;
    border-radius: 0 !important;
}

.post-foot__icon:hover {
    scale: 1.05;
    transition: all 0.2s ease-in-out;
}


.post-foot__link {
    color: var(--ComplementaryColor04);
    text-decoration: none;
    font-size: 1.5rem;
    font-weight: 700;
}

.post-foot__link:hover {
    color: var(--ComplementaryColor04);
    scale: 1.01;
    transition: all 0.2s ease-in-out;
}

@media only screen and (max-width: 768px) {
    .post-foot {
        margin: 0;
        padding: 0;
        gap: 6rem;
    }

    .post-foot__link {
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.2;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .post-foot__icon {
        height: 85px;
    }
}
</style>
<script setup>
import { getBlogCollection } from '@/assets/markdowns/blog/BlogCollection.js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const route = useRoute();
const { locale } = useI18n();

const post = computed(() => {
    const posts = getBlogCollection(locale.value) || [];
    if (!Array.isArray(posts)) {
        console.error('Posts is not an array');
        return [];
    }
    return posts.filter(post => post.slug !== route.params.id).sort((a, b) => new Date(b.date) - new Date(a.date))[0];
});

</script>